// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","footerLinks":"Footer_footerLinks__Mudwb","link":"Footer_link__MsGIJ"};